import { Link } from 'react-router-dom';

interface ArticleSidebarProps {
  article: {
    cast: { name: string; role: string; avatar: string }[];
    relatedArticles: { id: string; title: string; cover: string }[];
  };
}

export default function ArticleSidebar({ article }: ArticleSidebarProps) {
  return (
    <aside className="lg:col-span-1">
      <div className="sticky top-24 space-y-6">
        <div className="bg-background-100 rounded-lg p-5">
          <h3 className="text-base font-semibold text-foreground-900 mb-4 flex items-center gap-2">
            <i className="ri-user-voice-line text-primary-500"></i>
            声优阵容
          </h3>
          <div className="space-y-3">
            {article.cast.map((c) => (
              <div key={c.name} className="flex items-center gap-3">
                <img
                  src={c.avatar}
                  alt={c.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-900 truncate">{c.name}</p>
                  <p className="text-xs text-foreground-500 truncate">{c.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {article.relatedArticles.length > 0 && (
          <div className="bg-background-100 rounded-lg p-5">
            <h3 className="text-base font-semibold text-foreground-900 mb-4 flex items-center gap-2">
              <i className="ri-links-line text-primary-500"></i>
              相关推荐
            </h3>
            <div className="space-y-3">
              {article.relatedArticles.map((rel) => (
                <Link
                  key={rel.id}
                  to={`/article/${rel.id}`}
                  className="flex items-center gap-3 group cursor-pointer"
                >
                  <img
                    src={rel.cover}
                    alt={rel.title}
                    className="w-20 h-12 rounded object-cover flex-shrink-0"
                  />
                  <span className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {rel.title}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </aside>
  );
}